<template>
    <ValidationObserver ref="observer">
        <div>
            <!-- first card starts -->
            <b-card>
                <b-row>
                    <div class="tenantProfile_img">
                        <single-image
                            class="profile-img"
                            height="150px"
                            width="130px"
                            @change="(d) => uploadImage('profilePhoto', d)"
                            :id="'profilePhoto'"
                            ref="profilePhoto"
                            :url="userInfo.profilePhoto"
                            label="Browse Profile Photo"
                        ></single-image>
                        <span
                            v-if="userInfo && userInfo.unsuppprtedFile"
                            class="validate-error"
                            >Unsupported file format! Please select an
                            image</span
                        >
                    </div>

                    <b-col>
                        <!-- Second Column -->
                        <b-row>
                            <b-col>
                                <ValidationProvider
                                    rules="required|alpha_spaces"
                                    v-slot="{ errors }"
                                    name="First Name"
                                >
                                    <c-input
                                        inputType="text"
                                        inputId="FirstName"
                                        lableText="First Name *"
                                        v-model="userinfo.first"
                                        class="mt-0 mb-4 mt-2"
                                    />
                                    <span class="validate-error custm-err">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <ValidationProvider
                                    rules="required|alpha_spaces"
                                    v-slot="{ errors }"
                                    name="Last Name"
                                >
                                    <c-input
                                        inputType="text"
                                        inputId="LastName"
                                        lableText="Last Name *"
                                        v-model="userinfo.last"
                                        class="mt-0 mb-4 mt-2"
                                    />
                                    <span class="validate-error custm-err">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-col>
                    <b-col>
                        <!-- Third Column -->
                        <b-row>
                            <b-col>
                                <ValidationProvider
                                    rules="required|email|no-capital-first-letter"
                                    v-slot="{ errors }"
                                    name="Email"
                                >
                                    <c-input
                                        inputType="text"
                                        inputId="Email"
                                        lableText="Email *"
                                        v-model="userinfo.email"
                                        class="mt-2 mb-2"
                                    />
                                    <span
                                        v-if="errors[0]"
                                        class="validate-error custm-err"
                                        >{{ errors[0] }} (First letter should be
                                        small)</span
                                    >
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <ValidationProvider
                                    rules="required|max:15|min:10"
                                    v-slot="{ errors }"
                                    name="Phone no"
                                >
                                    <c-tel-input
                                        v-model="userinfo.phone"
                                        class="m-0 mb-2 mt-4"
                                    />
                                    <span class="validate-error custm-err">{{
                                        errors[0]
                                    }}</span>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
            </b-card>

            <!-- end of first card -->
            <b-card>
                <div class="heading">More Details</div>
                <b-row class="mt-1">
                    <b-col md="6">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Education"
                        >
                            <label></label>
                            <c-input
                                inputType="text"
                                inputId="Education"
                                lableText="Education *"
                                v-model="userinfo.education"
                            ></c-input>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <label></label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Working Experience"
                        >
                            <c-input
                                inputType="number"
                                inputId="Experience"
                                lableText="Working Experience *"
                                v-model="userinfo.value"
                            />
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <label for="UOM">UOM</label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="UOM"
                        >
                            <eb-select
                                type="text"
                                v-model="userinfo.uom"
                                :options="['Days', 'Months', 'Years']"
                                label="label"
                                placeholder="UOM *"
                            ></eb-select>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>

                    <b-col md="6">
                        <label for="DOB">DOB</label>
                        <ValidationProvider
                            rules="required|futureDate"
                            v-slot="{ errors }"
                            name="DOB"
                        >
                            <b-input
                                id="activation-date"
                                type="date"
                                v-model="userinfo.dob"
                            ></b-input>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <label for="Gender">Gender</label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Gender"
                        >
                            <eb-select
                                type="text"
                                v-model="userinfo.gender"
                                :options="['Female', 'Male', 'Others']"
                                label="label"
                                placeholder="Gender *"
                            ></eb-select>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="6">
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="Marital Status"
                        >
                            <label for="Marital Status">Marital Status</label>
                            <eb-select
                                type="text"
                                v-model="userinfo.maritalStatus"
                                :options="['Single', 'Married']"
                                label="label"
                                placeholder="Marital Status *"
                            ></eb-select>
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                    <b-col md="12">
                        <label></label>
                        <ValidationProvider
                            rules="required"
                            v-slot="{ errors }"
                            name="About Me"
                        >
                            <c-input
                                inputType="text"
                                inputId="AboutMe"
                                lableText="About Me *"
                                v-model="userinfo.aboutMe"
                            />
                            <span class="validate-error custm-err">{{
                                errors[0]
                            }}</span>
                        </ValidationProvider>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col>
                        <DynamicInput
                            :fields="externalInfoUser"
                            :visibility="isVisible"
                            ref="dynamicForm"
                            @update:formData="handleExtendedAttributesUpdate"
                        />
                    </b-col>
                </b-row>
                <slot
                    name="footer-button"
                    :data="{ userinfo, extendedAttributes }"
                ></slot>
            </b-card>
        </div>
    </ValidationObserver>
</template>
<script>
import {
    ValidationProvider,
    ValidationObserver,
    Validator,
} from "vee-validate";
import cInput from "@/components/FormElements/CustomInput";
import cTelInput from "@/components/FormElements/MobileNumberInput";
import ebSelect from "@/components/FormElements/Select";
import SingleImage from "../../components/Common/Image.vue";
import Vue from "vue";
import moment from "moment";
import DynamicInput from "../../components/Partner/additionalInfo.vue";
import { mapState } from "vuex";
export default {
    name: "userinfoStepper",
    props: {
        userInfo: {
            type: Object,
            required: false,
            default: () => ({
                firstName: "",
                lastName: "",
                value: "",
                uom: "",
                dob: "",
                gender: "",
                profilePhoto: "",
                authentication: {
                    email: "",
                    phone: "",
                },
                unsuppprtedFile: false,
                maritalStatus: "",
                education: "",
                aboutMe: "",
            }),
        },
    },
    data() {
        return {
            extendedAttributes: {},
            externalInfoUser: [],
            userinfo: {
                first: "",
                last: "",
                email: "",
                phone: "",
                value: "",
                uom: "",
                gender: "",
                dob: "",
                profilePhoto: "",
                maritalStatus: "",
                education: "",
                aboutMe: "",
            },
        };
    },
    components: {
        DynamicInput,
        cInput,
        cTelInput,
        ebSelect,
        SingleImage,
        ValidationObserver,
        ValidationProvider,
    },
    computed: {
        ...mapState({
            extendedList: (state) => state.tenant.extendedList,
        }),
        isVisible() {
            return this.externalInfoUser && this.externalInfoUser.length >= 0;
        },
    },
    watch: {
        // keep local userinfo updated when parent sends new data
        userInfo: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.userinfo = {
                    first: newVal.firstName || "",
                    last: newVal.lastName || "",
                    email: newVal.authentication?.email || "",
                    phone: newVal.authentication?.phone || "",
                    dob: newVal.dob || "",
                    value: newVal.value || "",
                    uom: newVal.uom || "",
                    gender: newVal.gender || "",
                    profilePhoto: newVal.profilePhoto || "",
                    maritalStatus: newVal.maritalStatus || "",
                    education: newVal.education || "",
                    aboutMe: newVal.aboutMe || "",
                };
            },
        },
        // push local edits back to parent
        userinfo: {
            deep: true,
            handler(updated) {
                this.$emit("update:userInfo", {
                    firstName: updated.first,
                    lastName: updated.last,
                    authentication: {
                        email: updated.email,
                        phone: updated.phone,
                    },
                    dob: updated.dob,
                    value: updated.value,
                    uom: updated.uom,
                    gender: updated.gender,
                    profilePhoto: updated.profilePhoto,
                    maritalStatus: updated.maritalStatus,
                    education: updated.education,
                    aboutMe: updated.aboutMe,
                });
            },
        },
    },
    methods: {
        handleExtendedAttributesUpdate(updatedData) {
            this.extendedAttributes = updatedData;
        },
        async getAttributeList() {
            this.$store.dispatch("tenant/setExtendedAttributeList").then(() => {
                this.externalInfoUser = this.extendedList.externalInfoAdmin;
            });
        },
        showCustomToast() {
            Vue.toasted.show("Uploading...", {
                type: "info",
                theme: "toasted-primary",
                singleton: true,
                duration: 1000000,
            });
        },
        clearCustomToast() {
            Vue.toasted.clear();
        },
        isValid() {
            const isValid = this.$refs.observer.validate();
            this.$emit("isValid", isValid);
            return isValid;
        },
        async uploadImage(path, image) {
            if (!image.includes("data:image")) {
                this.userinfo[path] = null;
                this.userInfo.unsuppprtedFile = true;

                return;
            }
            this.userInfo.unsuppprtedFile = false;

            let dataobj = {
                image: image,
                key: (
                    Date.now().toString(36) +
                    Math.random().toString(36).substr(2, 5)
                ).toLowerCase(),
                isPublic: true,
                replaceExisting: true,
                basePath: ["agent", "profilePhoto"],
            };
            this.showCustomToast();
            await this.$store
                .dispatch("inventory/uploadImageToStorage", dataobj)
                .then((res) => {
                    this.clearCustomToast();
                    this.userinfo[path] = res.data.fileUrl;
                })
                .catch((error) => {
                    this.clearCustomToast();
                    this.$toasted.error(
                        "Image not uploaded..please try again!",
                    );
                });
        },
    },
    mounted() {
        this.getAttributeList();
        this.today = moment().format("DD-MM-yyyy");
        Validator.extend(
            "futureDate",
            (value, [otherValue]) => {
                return moment().diff(value, "day") >= 1;
            },
            {
                hasTarget: true,
            },
        );
        Validator.extend("no-capital-first-letter", {
            validate(value) {
                return value[0] !== value[0].toUpperCase();
            },
        });
    },
};
</script>
<style scoped>
.location-search {
    border-radius: 0rem;
    color: rgb(0, 0, 0);
    box-shadow: none !important;
    font-family: "Lato";
    height: 39px !important;
    border: 1px solid #dee2e6;
    padding-left: 10px;
    width: 100%;
    font-size: small;
}

[btn-color="primary"] {
    height: 41px;
    background-color: var(--primary);
    font-weight: 600;
    font-size: medium;
    letter-spacing: 2px;
    font-family: "Lato";
    color: white;
    border: 0px;
    border-radius: 0px;
}

[btn-special="primary"] {
    border: 0px;
    font-weight: 500;
    letter-spacing: 1px;
    font-size: medium;
    font-family: "Lato";
    border-radius: 0px;
    height: 43px;
    width: 139px;
    background-color: var(--primary);
    color: white;
}

/* .custom-file-label {
  border-radius: 0px !important;
  border: 1px solid #dee2e6 !important;
  color: #dee2e6 !important;
} */

.tenantProfile_img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    position: relative;
    overflow: hidden;
    border: 2px solid #4645e7;
    margin: 0 auto;
    margin-top: 5px;
    background-image: #fff;
    background-size: cover;
    background-position: center top;
}
.profile-img {
    margin-top: -20px;
    margin-left: -6px;
}
/* .tenantProfile_img img {
  max-width: 145px;
  width: auto;
  max-height: 145px;
  height: 100%;
  border-radius: 50%;
  border: 4px solid transparent;
  margin-bottom: 0px;
  object-fit: cover;
} */
.card {
    border-width: 1160px;
    border-radius: 16px;
    /* box-shadow: 0 0 35px 0 rgba(154, 161, 171, 0.15) !important; */
}
.heading {
    font-size: 18px;
    font-weight: 700;
    color: #000000;
}
.custm-err {
    color: red;
}
</style>
